"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.map.js");

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ol = require("ol");

var _FullScreen = _interopRequireDefault(require("ol/control/FullScreen"));

require("ol/ol.css");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Provides a button that when clicked fills up the full screen with the map
 * 
 * @visibleName Full Screen Control
 */
var FullScreenControl = function FullScreenControl(_ref) {
  var map = _ref.map,
      options = _ref.options;
  (0, _react.useEffect)(function () {
    var control = new _FullScreen.default(options);
    map.addControl(control);
    return function () {
      map.removeControl(control);
    };
  }, [map, options]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
};

FullScreenControl.propTypes = {
  /**
   * The OpenLayers ol/Map on where the component
   * will zoom.
   */
  map: _propTypes.default.instanceOf(_ol.Map),

  /**
   * The options for the component. It is 
   * the same used for the openlayers 
   * <a href="https://openlayers.org/en/latest/apidoc/module-ol_control_FullScreen-FullScreen.html">
   * ol/control/FullScreen</a>
   */
  options: _propTypes.default.object
};
var _default = FullScreenControl;
exports.default = _default;